// 网格分页状态机（Product / Funding / Channel 三 grid 共用）
//
// 用法：在 grid 组件中 mixins: [gridPaginationMixin]，并：
//   - data 中保留 itemsPerPage（每页条数，三 grid 不同：12 / 6 / 9）
//   - 通过 sourceKey 指定数据源 prop 名（默认 'products'，Channel 为 'channels'）
//   - 通过 paginationGtagLabel 指定 GA 事件后缀（product / funding / channel）
//   - 通过 infiniteScroll 控制是否附加滚动无限加载（Channel 仅按钮翻页，设为 false）
//
// 模板中以 displayedItems 渲染卡片列表，show-more 按钮调用 loadMore()。
export default {
  data() {
    return {
      currentPage: 1,
      displayedItems: [], // 已展开渲染的条目（原 displayedProducts / displayedChannels）
      isLoading: false,
      scrollThreshold: 30, // 距离底部多少像素时触发加载
      sourceKey: 'products', // 数据源 prop 名，子类按需覆盖
      paginationGtagLabel: 'product', // GA 事件名后缀
      infiniteScroll: true, // 是否启用滚动无限加载
    };
  },
  computed: {
    hasMoreItems() {
      const source = this[this.sourceKey] || [];
      return this.displayedItems.length < source.length;
    },
  },
  created() {
    // 数据源变化时（含首次）重置展示列表
    this.$watch(
      () => this[this.sourceKey],
      (newVal) => {
        if (newVal && newVal.length) {
          this.displayedItems = newVal.slice(0, this.itemsPerPage);
        } else {
          this.displayedItems = [];
        }
      },
      { immediate: true }
    );
  },
  mounted() {
    if (this.infiniteScroll) {
      window.addEventListener('scroll', this.handleScroll);
    }
  },
  beforeUnmount() {
    if (this.infiniteScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    handleScroll() {
      if (this.isLoading || !this.hasMoreItems) return;

      const scrollHeight = document.documentElement.scrollHeight;
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const clientHeight = window.innerHeight || document.documentElement.clientHeight;

      if (scrollHeight - scrollTop - clientHeight <= this.scrollThreshold) {
        this.loadMore();
      }
    },
    loadMore() {
      if (this.isLoading || !this.hasMoreItems) return;

      this.isLoading = true;

      try {
        this.currentPage += 1;
        const source = this[this.sourceKey] || [];
        const start = this.displayedItems.length;
        const end = start + this.itemsPerPage;

        this.displayedItems = this.displayedItems.concat(source.slice(start, end));

        if (window.gtag) {
          window.gtag('event', `load_more_${this.paginationGtagLabel}`, {
            event_category: 'Pagination',
            event_label: this.paginationGtagLabel,
            value: this.displayedItems.length,
          });
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
